module.exports = __webpack_public_path__ + "img/typehoon50_all.3f410023.png";